import { m as merge, g as getValueByPath, b as blankIfUndefined } from './helpers-d639255d.js';

var config = {
  iconPack: 'mdi',
  useHtml5Validation: true,
  statusIcon: true
};

var _setOptions = function setOptions(options) {
  config = options;
};
var VueInstance;
var setVueInstance = function setVueInstance(Vue) {
  VueInstance = Vue;
};
var Programmatic = {
  getOptions: function getOptions() {
    return config;
  },
  setOptions: function setOptions(options) {
    _setOptions(merge(config, options, true));
  }
};
var Plugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setVueInstance(Vue); // Options

    _setOptions(merge(config, options, true));
  }
};

var BaseComponentMixin = {
  methods: {
    computedClass: function computedClass(component, field, defaultValue) {
      var override = getValueByPath(config, "".concat(component, ".override"), false);
      var gloabalClazz = getValueByPath(config, "".concat(component, ".").concat(field), '');
      var currrentClazz = this.$props[field];
      return "".concat(override ? '' : defaultValue, " ").concat(blankIfUndefined(gloabalClazz), " ").concat(blankIfUndefined(currrentClazz)).trim();
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var use = function use(plugin) {
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
  }
};
var registerComponent = function registerComponent(Vue, component) {
  Vue.component(component.name, component);
};
var registerComponentProgrammatic = function registerComponentProgrammatic(Vue, property, component) {
  if (!Vue.prototype.$oruga) Vue.prototype.$oruga = {};
  Vue.prototype.$oruga[property] = component;
};

export { BaseComponentMixin as B, Programmatic as P, VueInstance as V, _setOptions as _, Plugin as a, registerComponent as b, config as c, normalizeComponent as n, registerComponentProgrammatic as r, setVueInstance as s, use as u };
